import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";

const BatchListing = () => {
  const [showFilters, setShowFilters] = useState(false);

  return (
    <div className="container-fluid" style={{ minHeight: "538px", paddingTop: "10px" }}>
      <div className="page-header fw-bold" style={{borderBottom:'2px solid #90b732', color:'#90b732', fontSize:'16px', paddingBottom:'8px'}}>Batch Listing</div>

      {/* Buttons */}
      <div className="row mb-2 mt-2">
        <div className="col-sm-12 col-md-6 ">
          <div className="btn-group ">
            <button
              type="button"
              className="btn btn-default border "
              onClick={() => setShowFilters(!showFilters)}
            >
              <img
                src="https://tallyeducation.com/tallyweb/modules/lib/templates/resources/images/filters-icon.png"
                alt="Filters"
              />
            </button>
            <button type="button" className="btn btn-default border ">
              <img
                src="https://tallyeducation.com/tallyweb/modules/tepl/intranet/images/icon_export.gif"
                alt="Export"
              />
            </button>
          </div>
        </div>
        <div className="col-sm-12 col-md-6 text-end">
          <button type="button" className="btn btn-default border bg-light">
            Add Batch
          </button>
        </div>
      </div>

      {/* Filter Pane */}
      {showFilters && (
        <div className="row mb-3 ">
          <div className="col-12 ">
            <div className="panel panel-default ">
              <div className="panel-heading">
                <h3 className="panel-title">Filters</h3>
              </div>
              <div className="panel-body">
                <form>
                  <div className="row mb-3">
                    <div className="col-sm-3">
                      <label>For Period</label>
                      <select className="form-control" defaultValue="This Year">
                        <option>Today</option>
                        <option>Yesterday</option>
                        <option>Yesterday & today</option>
                        <option>Last 7 Days</option>
                        <option>Last 15 Days</option>
                        <option>Last Month</option>
                        <option>This Month</option>
                        <option>This Year</option>
                        <option>Last Financial Year</option>
                        <option>This Financial Year</option>
                        <option>Till Today</option>
                        <option>Mention Period</option>
                      </select>
                    </div>
                    <div className="col-sm-3">
                      <label>From Date</label>
                      <input type="text" className="form-control" value="01-01-2025" disabled />
                    </div>
                    <div className="col-sm-3">
                      <label>To Date</label>
                      <input type="text" className="form-control" value="31-12-2025" disabled />
                    </div>
                    <div className="col-sm-3">
                      <label>Status</label>
                      <select className="form-control" defaultValue="Select">
                        <option>Select</option>
                        <option>Active</option>
                        <option>Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12 text-end">
                      <button type="button" className="btn btn-default me-2">
                        Reset
                      </button>
                      <button type="button" className="btn btn-default">
                        Show
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Table */}
      <div className="row ">
        <div className="col-12 ">
          <div className="panel panel-default ">
            <div className="panel-body p-0 ">
              <div className="table-responsive ">
                <table className="table table-striped table-hover ">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center", width: "1%" }}>#</th>
                      <th style={{ textAlign: "center", width: "12%" }}>Batch Name</th>
                      <th style={{ textAlign: "center", width: "5%" }}>Student Count</th>
                      <th style={{ textAlign: "center", width: "5%" }}>Course Name</th>
                      <th style={{ textAlign: "center", width: "6%" }}>Status</th>
                      <th style={{ textAlign: "center", width: "3%" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="6" className="text-center">
                        No Records Found
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BatchListing;
